// src/pages/IGKQuickSelectPage.js
import React, { useEffect, useState } from 'react';
import Navbar from '../components/NavBar';
import { AnimatePresence, motion } from "framer-motion";
import { Range } from 'react-range';

import HRU_PRODUCTS from '../data/hruProducts';


function matchHru({ type, flow, tolMin, tolMax }) {
  const f = Number(flow);
  if (!type || isNaN(f)) return [];

  const fMin = f * (1 + tolMin / 100);
  const fMax = f * (1 + tolMax / 100);

  return HRU_PRODUCTS
    .filter(prd =>
      prd.type === type &&
      prd.flow >= fMin &&
      prd.flow <= fMax
    )
    .sort((a, b) => {
      const diffA = Math.abs(((a.flow - f) / f) * 100);
      const diffB = Math.abs(((b.flow - f) / f) * 100);
      return diffA - diffB;
    });
}


export default function IGKQuickSelectPage() {
  const [username, setUsername] = useState('Ziyaretçi');

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        setUsername(payload.username || 'Ziyaretçi');
      } catch {
        setUsername('Ziyaretçi');
      }
    }
  }, []);

  const [simpleType, setSimpleType] = useState('Standart');
  const [simpleFlow, setSimpleFlow] = useState('');

  // Tek imleçle kontrol edilecek default tolerans
  const [flowTolerance, setFlowTolerance] = useState([-30, 30]);

  const [simpleMatches, setSimpleMatches] = useState([]);
  const [simpleTried, setSimpleTried] = useState(false);

  const handleSimpleFind = () => {
    setSimpleTried(true);
    const result = matchHru({
      type: simpleType,
      flow: simpleFlow,
      tolMin: flowTolerance[0],
      tolMax: flowTolerance[1],
    });
    setSimpleMatches(result);
  };

  return (
    <>
      <Navbar username={username} />
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: 20 }}>
        <h1>Isı Geri Kazanım Cihazı Seçimi</h1>

        <div style={{
          margin: '10px 0 20px',
          padding: 16,
          border: '1px solid #e5e7eb',
          borderRadius: 12,
          background: '#fff'
        }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
            gap: 12,
            alignItems: 'center'
          }}>
            <div>
              <label style={{ fontWeight: 600, marginBottom: 6, display: 'block' }}>Cihaz Tipi:</label>
              <select
                value={simpleType}
                onChange={(e) => setSimpleType(e.target.value)}
                style={{
                  width: '100%',
                  height: '42px',
                  padding: '0 10px',
                  border: '1px solid #ccc',
                  borderRadius: 8,
                  fontSize: '14px'
                }}
              >
                <option value="Standart">Standart</option>
                <option value="Bataryalı">Bataryalı</option>
                <option value="Kompresörlü">Kompresörlü</option>
              </select>
            </div>

            <div>
              <label style={{ fontWeight: 600, marginBottom: 6, display: 'block' }}>Hava Debisi (m³/h):</label>
              <input
                type="number"
                value={simpleFlow}
                onChange={(e) => setSimpleFlow(e.target.value)}
                placeholder="Örn: 4200"
                style={{ width: '100%', padding: 10, border: '1px solid #ccc', borderRadius: 8 }}
              />
            </div>

            <div>
              <label style={{ fontWeight: 600, marginBottom: 6, display: 'block' }}>Debi Tolerans:</label>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <input
                  type="number"
                  value={flowTolerance[0]}
                  onChange={(e) => {
  let val = Number(e.target.value);
  if (val > 0) val = -val; // Pozitifse otomatik olarak negatife çevir
  setFlowTolerance([val, flowTolerance[1]]);
}}

                  style={{ width: 60, textAlign: 'center', border: '1px solid #ccc', borderRadius: 6 }}
                />
                <span>%</span>

                {/* Tek imleçli Range */}
                <Range
                  step={1}
                  min={0}
                  max={300}
                  values={[flowTolerance[1]]} // sadece + tolerans kontrol ediliyor
                  onChange={(values) => {
                    const val = values[0];
                    setFlowTolerance([-val, val]); // ikisi de aynı anda değişiyor
                  }}
                  renderTrack={({ props, children }) => (
                    <div
                      {...props}
                      style={{
                        flex: 1,
                        height: 12,
                        background: "#ddd",
                        borderRadius: 6,
                        display: "flex",
                        alignItems: "center",
                        marginRight: "20px"
                      }}
                    >
                      {children}
                    </div>
                  )}
                  renderThumb={({ props }) => (
                    <div
                      {...props}
                      style={{
                        height: 24,
                        width: 24,
                        borderRadius: "50%",
                        backgroundColor: "#007bff",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "white",
                        fontSize: 10,
                        fontWeight: "bold",
                        boxShadow: "0 0 4px rgba(0,0,0,0.3)"
                      }}
                    >
                      %
                    </div>
                  )}
                />

                <input
                  type="number"
                  value={flowTolerance[1]}
                  onChange={(e) => setFlowTolerance([flowTolerance[0], Number(e.target.value)])}
                  style={{ width: 60, textAlign: 'center', border: '1px solid #ccc', borderRadius: 6 }}
                />
                <span>%</span>
              </div>
            </div>
          </div>

          <div style={{ marginTop: 12 }}>
            <button
              onClick={handleSimpleFind}
              style={{
                backgroundColor: '#03a9f4',
                color: 'white',
                fontWeight: 700,
                border: 'none',
                borderRadius: 8,
                padding: '10px 16px',
                cursor: 'pointer',
              }}
            >
              Ürün Seç
            </button>
          </div>
        </div>

        {simpleTried && (
          <div style={{ marginTop: 16 }}>
            {simpleMatches.length === 0 ? (
              <div style={{
                padding: 12,
                border: '1px dashed #ccc',
                borderRadius: 8,
                color: '#475569',
                background: '#fff'
              }}>
                Uygun ürün bulunamadı. Debi toleransını veya cihaz tipini değiştirip tekrar deneyiniz.
              </div>
            ) : (
             <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
  <AnimatePresence>
    {simpleMatches.map((p) => (
     <motion.div
  key={p.id}
  initial={{ opacity: 0, y: 20 }}
  animate={{ opacity: 1, y: 0 }}
  exit={{ opacity: 0, y: -20 }}
  transition={{ duration: 0.3 }}
  style={{
    display: 'flex',
    flexDirection: window.innerWidth < 768 ? 'column' : 'row', // ✅ Mobilde alt alta
    alignItems: window.innerWidth < 768 ? 'flex-start' : 'center',
    justifyContent: 'space-between',
    gap: window.innerWidth < 768 ? '12px' : '0',
    border: '1px solid #e5e7eb',
    borderRadius: 8,
    padding: '20px 16px',
    background: '#fff',
    height: 'auto' // Mobilde yükseklik serbest
  }}
>
  <div style={{ display: 'flex', alignItems: 'center', gap: 20, height: '100%' }}>
    <div style={{
      height: '100%',
      width: '200px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <img
        src={p.image}
        alt={p.model}
        style={{
          maxHeight: '100%',
          maxWidth: '100%',
          objectFit: 'contain',
          borderRadius: 8
        }}
      />
    </div>

<div style={{
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: '100%',
  padding: '10px 0'
}}>
  {/* Ürün bilgileri */}
<div style={{
  fontSize: 18,
  fontWeight: '600',
  lineHeight: '1.6',
}}>
  {[
    { label: 'Marka', value: p.brand, color: '#dc2626' }, // 🔴 kırmızı
    { label: 'Model', value: p.model, color: '#0d6efd' }, // 🔵 mavi
    { label: 'Tip', value: p.type, color: '#dc2626' },   // 🔴 kırmızı
    { label: 'Debi', value: `${p.flow.toLocaleString()} m³/h`, color: '#0d6efd' }, // 🔵 mavi
  ].map((item, i) => (
    <div key={i} style={{ display: 'flex' }}>
      <span style={{
        fontWeight: '700',
        fontSize: 20,
        color: '#000',
        minWidth: '80px', // ✅ sabit genişlik
        display: 'inline-block'
      }}>
        {item.label}:
      </span>
      <span style={{ color: item.color, marginLeft: '6px' }}>
        {item.value}
      </span>
    </div>
  ))}
</div>

  {/* Teknik döküman linki */}
 <a 
  href={p.catalog} 
  target="_blank" 
  rel="noopener noreferrer"
  style={{ 
    marginTop: '8px',
    display: 'inline-block',
    fontSize: '16px',
    fontWeight: '500',
    color: '#007bff',
    textDecoration: 'underline',
    cursor: 'pointer'
  }}
>
  Teknik Dökümana Buradan Ulaşabilirsiniz
</a>

</div>

  </div>

  <a
    href={`https://wa.me/905346846935?text=Merhaba,%20${p.brand} ${p.model} (${p.id})%20ürünü%20hakkında%20bilgi%20almak%20istiyorum.`}
    target="_blank"
    rel="noopener noreferrer"
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      backgroundColor: '#25D366',
      color: '#fff',
      border: 'none',
      borderRadius: 8,
      padding: '10px 16px',
      fontWeight: 600,
      fontSize: 15,
      cursor: 'pointer',
      textDecoration: 'none',
      whiteSpace: 'nowrap'
    }}
  >
    <img
      src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
      alt="WhatsApp"
      style={{ width: 20, height: 20 }}
    />
    Ürün Hakkında Bilgi Al
  </a>
</motion.div>


    ))}
  </AnimatePresence>
</div>

            )}
          </div>
        )}
      </div>
    </>
  );
}
